'use client'
import { motion } from 'motion/react'
import React, { useEffect, useState } from 'react'
import { useSlate } from 'slate-react'
import { addNode, removeElement } from '../services/node'
import { isBlockActive } from '../funcitons'
import { ImageUploader } from '../../files/upload-files'
import * as Dialog from '@radix-ui/react-dialog'
import {
  UploadFilesProvider,
  useUploadFiles,
} from '../../files/upload-files-context'
import { FileType } from '@repo/types/common'
import ButtonAdminComponent, { ButtonStyle } from '../../button-admin'
import { ImageIcon } from '@radix-ui/react-icons'

const FORMAT = 'image-uploaded'
export function MarkUploadImage(props: {
  dialogTitle: string
  fileType: FileType
  userId: number
}) {
  return (
    <UploadFilesProvider>
      <Render {...props} />
    </UploadFilesProvider>
  )
}

function Render({
  dialogTitle,
  className,
  fileType,
  userId,
}: {
  dialogTitle: string
  className?: string
  fileType: FileType
  userId: number
}) {
  const { files, urls, clear, setFilesIds } = useUploadFiles()
  const [isValid, setIsValid] = useState(false)
  const [open, setOpen] = useState(false)
  const editor = useSlate()
  const [isActive, node] = isBlockActive(editor, FORMAT)

  const onRemoveButton = () => {
    removeElement(editor, FORMAT)
    setOpen(false)
  }

  useEffect(() => {
    if (node && node.filesId && node.filesId.length > 0) {
      setFilesIds(node.filesId)
    } else {
      setFilesIds([])
    }
  }, [node])

  useEffect(() => {
    setIsValid(files.length + urls.length > 0)
  }, [files, urls])

  useEffect(() => {
    if (!open) {
      clear()
    }
  }, [open])

  const onSubmit = async (e) => {
    if (userId) {
      const formData = new FormData()

      files.forEach((file) => formData.append('files', file))
      formData.append('urls', JSON.stringify(urls))
      formData.append('userId', `${userId}`)
      formData.append('type', fileType)

      const response = await fetch(
        `${process.env.NEXT_PUBLIC_EXP_URL}/files/upload`,
        {
          method: 'POST',
          body: formData,
        }
      )

      if (response.ok) {
        const data = await response.json()
        // console.log({ data: data.files })
        addNode(editor, { type: FORMAT, text: '', filesId: data.files })
        setOpen(false)
      } else {
        console.log('Error al subir las imágenes.')
      }
    } else {
      console.log('There is no session...')
    }
  }

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger asChild>
        <motion.button
          whileTap={{ scale: 0.95 }}
          className={`toolbar-button ${isActive ? 'active' : ''} ${className ? ` ${className}` : ''}`}>
          <ImageIcon />
        </motion.button>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="overlay">
          <Dialog.Content className="container">
            <Dialog.Title className="DialogTitle"></Dialog.Title>
            <form onSubmit={onSubmit} className="card">
              <p className={'title'}>{dialogTitle}</p>

              <ImageUploader maxImages={1} />

              <div className="bottom-buttons">
                <Dialog.Close asChild>
                  <motion.button className="flex items-center justify-center rounded border border-gray-400 p-2 px-5 text-black disabled:bg-gray-400">
                    {'Cancelar'}
                  </motion.button>
                </Dialog.Close>
                {node !== false && (
                  <ButtonAdminComponent
                    text={'Quitar elemento'}
                    onClick={onRemoveButton}
                    loading={false}
                    disabled={node === false}
                    className={'w-fit'}
                    style={ButtonStyle.RED}
                  />
                )}
                <ButtonAdminComponent
                  type={'button'}
                  text={'Añadir imagen'}
                  onClick={onSubmit}
                  loading={false}
                  disabled={!isValid}
                  className={'w-fit'}
                  style={ButtonStyle.PRIMARY}
                />
              </div>
            </form>
          </Dialog.Content>
        </Dialog.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
